import { useState } from "react";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import DevisModal from "../components/DevisModal";

const BANNER_IMG = "https://customer-assets.emergentagent.com/job_precision-amour/artifacts/iilttym4__%20%284%29.jpeg";

const services = [
  {
    num: "01",
    name: "SYMPHONIE",
    type: "Organisation Complète",
    tagline: "Pour les couples qui souhaitent tout vivre… sans rien gérer.",
    intro: "Votre mariage est bien plus qu'un événement : c'est une histoire, une vision, une émotion.\n\nLa formule SYMPHONIE est l'accompagnement le plus complet que je propose : une prise en charge totale, de la première idée jusqu'au dernier instant du jour J.\n\nVous arrivez avec une vision, parfois simplement une émotion. Je construis ensuite chaque détail : la direction artistique, la sélection des prestataires, l'organisation logistique et la coordination globale pour donner vie à un mariage élégant, fluide et parfaitement orchestré.\n\nTout au long de l'organisation, je vous accompagne dans chaque décision afin de transformer votre projet en une expérience unique et sur mesure.\n\nLe jour de votre mariage, mon équipe et moi nous sommes présents avec discrétion et précision pour superviser chaque moment, anticiper les imprévus et garantir le bon déroulement de la journée.\n\nVotre seule mission : vivre pleinement chaque instant de votre mariage.",
    includes: [
      "Accompagnement complet sur 12 à 18 mois",
      "Définition stratégique de votre vision et structuration d'un budget cohérent",
      "Création de la direction artistique et des moodboards",
      "Recherche et sélection sur mesure des lieux et prestataires",
      "Rétroplanning complet et suivi régulier jusqu'au jour J",
      "Accès à votre espace client digital privé",
      "Sécurisation contractuelle et gestion administrative des prestataires",
      "Coordination des cérémonies civiles, religieuses ou traditionnelles",
      "Élaboration du planning détaillé minute par minute",
      "Gestion de la logistique et des invités",
      "Coordination complète le jour J avec minimum deux membres de l'équipe",
      "Supervision des temps forts et gestion discrète des imprévus",
    ],
    bonus: [
      "Création de vos faire-part digitaux personnalisés (Save the Date & invitations)",
      "Service de conciergerie invités : hébergements, informations logistiques et FAQ du week-end",
    ],
    pricing: null,
    cta: { label: "Demander un devis", href: "https://calendly.com/ellaa-wedding/30min" },
  },
  {
    num: "02",
    name: "CADENCE",
    type: "Organisation Partielle",
    tagline: "Destinée aux couples ayant déjà avancé et souhaitant sécuriser et harmoniser leur organisation.",
    intro: null,
    includes: [
      "Audit complet de votre projet et relecture des contrats signés",
      "Optimisation budgétaire et structuration du rétroplanning",
      "Recherche des prestataires manquants (jusqu'à 4 catégories clés)",
      "Harmonisation de l'univers et coordination des traditions",
      "Élaboration du planning détaillé",
      "Accompagnement au rendez-vous technique du lieu",
      "Coordination complète le jour J par une équipe dédiée",
    ],
    bonus: [
      "Création de vos faire-part digitaux personnalisés (Save the Date & invitations)",
      "Service de conciergerie invités : hébergements, informations logistiques et FAQ du week-end",
    ],
    pricing: null,
    cta: { label: "Demander un devis", href: "https://calendly.com/ellaa-wedding/30min" },
  },
  {
    num: "03",
    name: "APOGÉE",
    type: "Coordination Jour J",
    tagline: "Pour les couples qui ont tout organisé… et qui souhaitent vivre leur mariage pleinement.",
    intro: "Vous avez imaginé, planifié et organisé chaque détail de votre mariage. Il ne reste plus qu'une étape essentielle : confier la coordination du jour J à une équipe de confiance afin de profiter pleinement de cette journée unique.\n\nLa formule APOGÉE intervient dans les derniers mois de votre organisation. Je reprends votre dossier, j'analyse chaque élément et je coordonne l'ensemble des prestataires afin que tout se déroule avec fluidité et précision.\n\nChaque détail est revu, chaque intervenant est briefé et un planning minuté est élaboré pour garantir une parfaite orchestration de votre journée.\n\nLe jour de votre mariage, mon équipe et moi sommes présentes des préparatifs jusqu'à la dernière prestation afin de superviser chaque moment, coordonner les prestataires et gérer discrètement les imprévus.\n\nVotre seule mission : vivre pleinement votre mariage.",
    includes: [
      "Reprise et audit complet de votre organisation 3 mois avant le mariage",
      "Entretien immersion et analyse stratégique du planning",
      "Relecture des contrats et prise de contact avec l'ensemble des prestataires",
      "Réunion de coordination avec les prestataires clés",
      "Élaboration du planning détaillé minute-by-minute",
      "Coordination technique en amont et accompagnement du lieu",
      "Présence de l'équipe des préparatifs à la dernière prestation",
      "Coordination complète du jour J et gestion des prestataires",
      "Gestion des invités et résolution discrète des imprévus en temps réel",
    ],
    bonus: null,
    pricing: null,
    cta: { label: "Demander un devis", href: "https://calendly.com/ellaa-wedding/30min" },
  },
  {
    num: "04",
    name: "PRÉLUDE",
    type: "Coaching Mariés",
    tagline: "Pour les couples autonomes qui veulent organiser leur mariage avec méthode et sérénité.",
    intro: "Vous souhaitez tenir les rênes vous-mêmes, mais pas avancer à l'aveugle. PRÉLUDE, c'est la boussole que je vous tends. En séances individuelles, je vous transmets les outils, les réflexes et les connaissances d'une professionnelle du mariage multiculturel haut de gamme. Vous prenez chaque décision avec clarté, vous évitez les erreurs coûteuses, vous gagnez un temps précieux. Vous gardez la main, je vous donne la méthode.",
    includes: [
      "Séances de coaching individuel en visio (1h chacune)",
      "Checklist & rétroplannings personnalisés à votre situation",
      "Recommandations de prestataires selon votre profil et budget",
      "Révision et conseils sur vos contrats prestataires",
      "Accès à mes outils & ressources exclusifs ELLAA Wedding",
      "Support par message entre les séances",
    ],
    bonus: null,
    pricing: [
      { label: "Séance découverte 30 min", price: "Offerte" },
      { label: "Séance individuelle 1h", price: "150€" },
      { label: "Pack 3 séances", price: "390€" },
      { label: "Pack 5 séances", price: "600€" },
    ],
    cta: { label: "Réserver ma séance découverte", href: "https://calendly.com/ellaa-wedding/30min" },
  },
];

export default function Services() {
  useScrollReveal();
  const [devisFormule, setDevisFormule] = useState(null);

  return (
    <main className="page-fade" data-testid="services-page" style={{ paddingTop: "160px" }}>

      {devisFormule !== null && (
        <DevisModal formule={devisFormule} onClose={() => setDevisFormule(null)} />
      )}

      {/* Header */}
      <section style={{ padding: "60px 24px 0", backgroundColor: "#F7F3EA", textAlign: "center" }}>
        <p style={{ fontSize: "10px", letterSpacing: "5px", textTransform: "uppercase", color: "rgba(61,22,2,0.4)", marginBottom: "20px" }}>
          Nos Prestations
        </p>
        <h1 style={{
          fontFamily: "'Noto Serif Ethiopic', Georgia, serif",
          fontSize: "clamp(2.5rem, 6vw, 5rem)",
          fontWeight: 300, color: "#3D1602",
          letterSpacing: "-0.02em", lineHeight: 1.1, marginBottom: "20px",
        }}>
          Quatre formules, une seule promesse.
        </h1>
        <p style={{ fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontStyle: "italic", fontSize: "22px", color: "rgba(61,22,2,0.5)" }}>
          L'amour orchestré avec précision.
        </p>
      </section>

      {/* Image bannière */}
      <section style={{ backgroundColor: "#F7F3EA", padding: "48px 24px 80px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <img
            src={BANNER_IMG}
            alt="ELLAA WEDDING"
            style={{ width: "100%", height: "600px", objectFit: "cover", objectPosition: "center", display: "block" }}
          />
        </div>
      </section>

      {/* Services */}
      {services.map((svc, i) => (
        <section
          key={i}
          data-testid={`service-${svc.name.toLowerCase()}`}
          style={{
            padding: "80px 24px",
            backgroundColor: i % 2 === 0 ? "#F7F3EA" : "#EBE6DB",
            borderTop: "1px solid rgba(61,22,2,0.07)",
          }}
        >
          <div style={{ maxWidth: "860px", margin: "0 auto" }}>

            {/* Header prestation */}
            <div className="scroll-reveal" style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "40px" }}>
              <span style={{ fontSize: "11px", letterSpacing: "4px", color: "rgba(61,22,2,0.4)", fontFamily: "'Inter', sans-serif" }}>{svc.num}</span>
              <div style={{ flex: 1, height: "1px", backgroundColor: "rgba(61,22,2,0.1)" }} />
            </div>

            <p className="scroll-reveal" style={{
              fontFamily: "'Noto Serif Ethiopic', Georgia, serif",
              fontSize: "clamp(2rem, 4vw, 3rem)",
              fontWeight: 300, color: "#3D1602",
              letterSpacing: "2px", marginBottom: "8px",
            }}>
              {svc.name}
            </p>
            <p className="scroll-reveal" style={{
              fontSize: "10px", letterSpacing: "4px", textTransform: "uppercase",
              color: "#6D5E56", marginBottom: "24px",
            }}>
              {svc.type}
            </p>
            <p className="scroll-reveal delay-1" style={{
              fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontStyle: "italic",
              fontSize: "20px", color: "rgba(61,22,2,0.65)", marginBottom: "32px", lineHeight: 1.5,
            }}>
              {svc.tagline}
            </p>

            {/* Intro paragraphs */}
            {svc.intro && (
              <div className="scroll-reveal delay-1" style={{ marginBottom: "40px" }}>
                {svc.intro.split("\n\n").map((para, j) => (
                  <p key={j} style={{
                    fontSize: "14px", lineHeight: "1.9", color: "#6D5E56",
                    fontWeight: 300, marginBottom: "16px",
                  }}>
                    {para}
                  </p>
                ))}
              </div>
            )}

            {/* Ce qui est inclus */}
            <div className="scroll-reveal delay-2" style={{ marginBottom: "36px" }}>
              <p style={{
                fontSize: "10px", letterSpacing: "4px", textTransform: "uppercase",
                color: "#3D1602", marginBottom: "20px", fontFamily: "'Inter', sans-serif",
              }}>
                Ce que comprend la formule
              </p>
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {svc.includes.map((inc, j) => (
                  <li key={j} style={{
                    display: "flex", alignItems: "flex-start", gap: "14px",
                    fontSize: "14px", lineHeight: "1.8", color: "#6D5E56", fontWeight: 300,
                    padding: "10px 0",
                    borderBottom: j < svc.includes.length - 1 ? "1px solid rgba(61,22,2,0.06)" : "none",
                  }}>
                    <span style={{ color: "#3D1602", flexShrink: 0, marginTop: "2px" }}>·</span>
                    {inc}
                  </li>
                ))}
              </ul>
            </div>

            {/* Bonus */}
            {svc.bonus && (
              <div className="scroll-reveal delay-2" style={{
                padding: "24px 28px",
                backgroundColor: "rgba(61,22,2,0.04)",
                borderLeft: "2px solid #E9DCC4",
                marginBottom: "36px",
              }}>
                <p style={{ fontSize: "10px", letterSpacing: "4px", textTransform: "uppercase", color: "#6D5E56", marginBottom: "16px", fontFamily: "'Inter', sans-serif" }}>
                  Bonus
                </p>
                {svc.bonus.map((b, j) => (
                  <p key={j} style={{ fontSize: "13px", lineHeight: "1.8", color: "#6D5E56", fontWeight: 300, marginBottom: j < svc.bonus.length - 1 ? "8px" : 0 }}>
                    · {b}
                  </p>
                ))}
              </div>
            )}

            {/* Tarifs PRÉLUDE */}
            {svc.pricing && (
              <div className="scroll-reveal delay-2" style={{ marginBottom: "36px" }}>
                <p style={{ fontSize: "10px", letterSpacing: "4px", textTransform: "uppercase", color: "#3D1602", marginBottom: "20px", fontFamily: "'Inter', sans-serif" }}>
                  Tarifs
                </p>
                <div style={{ display: "flex", flexDirection: "column", gap: "0" }}>
                  {svc.pricing.map((p, j) => (
                    <div key={j} style={{
                      display: "flex", justifyContent: "space-between", alignItems: "baseline",
                      padding: "14px 0",
                      borderBottom: "1px solid rgba(61,22,2,0.08)",
                    }}>
                      <span style={{ fontSize: "14px", color: "#6D5E56", fontWeight: 300 }}>{p.label}</span>
                      <span style={{
                        fontFamily: "'Noto Serif Ethiopic', Georgia, serif",
                        fontSize: "18px", color: "#3D1602", fontWeight: 300,
                      }}>{p.price}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Tarif sur demande (Symphonie, Cadence, Apogée) */}
            {!svc.pricing && (
              <p className="scroll-reveal delay-2" style={{
                fontSize: "11px", letterSpacing: "3px", textTransform: "uppercase",
                color: "rgba(61,22,2,0.4)", marginBottom: "32px", fontFamily: "'Inter', sans-serif",
              }}>
                Tarif sur demande
              </p>
            )}

            {/* CTA */}
            <div className="scroll-reveal delay-3">
              <button
                onClick={() => setDevisFormule(svc.name)}
                data-testid={`service-cta-${i}`}
                className="btn-primary"
                style={{ border: "none", cursor: "pointer" }}
              >
                → {svc.cta.label}
              </button>
            </div>

          </div>
        </section>
      ))}

      {/* Phrase de clôture */}
      <section style={{ padding: "100px 24px 40px", backgroundColor: "#F7F3EA", textAlign: "center" }}>
        <div style={{ maxWidth: "700px", margin: "0 auto" }}>
          <p className="scroll-reveal" style={{
            fontFamily: "'Noto Serif Ethiopic', Georgia, serif",
            fontStyle: "italic",
            fontSize: "clamp(18px, 2.5vw, 24px)",
            color: "rgba(61,22,2,0.6)",
            lineHeight: 1.7,
            marginBottom: "60px",
          }}>
            Chaque formule peut être adaptée à votre situation. Parce qu'aucun mariage ne ressemble à un autre — et c'est exactement ce qui le rend inoubliable.
          </p>

          {/* CTA final */}
          <p className="scroll-reveal delay-1" style={{
            fontSize: "13px", color: "#6D5E56", fontWeight: 300, marginBottom: "24px", lineHeight: 1.8,
          }}>
            Vous ne savez pas quelle formule vous correspond ?
          </p>
          <div className="scroll-reveal delay-2">
            <a
              href="https://calendly.com/ellaa-wedding/30min"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="services-cta-final"
              className="btn-primary"
            >
              Réservons un appel découverte
            </a>
          </div>
        </div>
      </section>

    </main>
  );
}
